const OVERLAP = 'Overlap';
const SHIFT_IN_THE_PAST = 'ShiftInThePast';
const OPEN_SHIFT_MORE_REQUEST_THAN_SHIFTS_AVAILABLE = 'OpenShiftMoreRequestThanShiftsAvailable';
const OPEN_SHIFT_NOT_FOUND = 'OpenShiftNotFound';
const REST_BETWEEN_SHIFT = 'RestBetweenShift';
const CONFLICT_WITH_OTHER_REQUEST = 'ConflictWithOtherRequest';
const SHIFT_NOT_FOUND = 'ShiftNotFound';
const SUBMISSION_PERIOD_END_IN_FUTURE = 'SubmissionPeriodEndInFuture';
const EMPLOYEE_NOT_IN_HYPERFIND = 'EmployeeNotInHyperfind';
const ALLOWED_TIME_BEFORE_SHIFT = 'AllowedTimeBeforeShift';
const EMPLOYEE_ON_RESTRICTION = 'EmployeeOnRestriction';

export default Object.freeze({
    [OVERLAP]: 0,
    [SHIFT_IN_THE_PAST]: 1,
    [OPEN_SHIFT_MORE_REQUEST_THAN_SHIFTS_AVAILABLE]: 2,
    [OPEN_SHIFT_NOT_FOUND]: 3,
    [REST_BETWEEN_SHIFT]: 4,
    [CONFLICT_WITH_OTHER_REQUEST]: 5,
    [SHIFT_NOT_FOUND]: 6,
    [SUBMISSION_PERIOD_END_IN_FUTURE]: 7,
    [EMPLOYEE_NOT_IN_HYPERFIND]: 8,
    [ALLOWED_TIME_BEFORE_SHIFT]: 9,
    [EMPLOYEE_ON_RESTRICTION]: 10,
});

export const ManagerWarningTypeNames = Object.freeze({
    0: OVERLAP,
    1: SHIFT_IN_THE_PAST,
    2: OPEN_SHIFT_MORE_REQUEST_THAN_SHIFTS_AVAILABLE,
    3: OPEN_SHIFT_NOT_FOUND,
    4: REST_BETWEEN_SHIFT,
    5: CONFLICT_WITH_OTHER_REQUEST,
    6: SHIFT_NOT_FOUND,
    7: SUBMISSION_PERIOD_END_IN_FUTURE,
    8: EMPLOYEE_NOT_IN_HYPERFIND,
    9: ALLOWED_TIME_BEFORE_SHIFT,
    10: EMPLOYEE_ON_RESTRICTION,
});
